
import '../css/LoadingPage.css'
import { useEffect, useRef ,useState } from "react";
// import Help from "../images/loading_page_help.png"
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { useParams,useLocation } from 'react-router-dom'
import { useLottie } from "lottie-react";
import YoomLoading from "./../Lotties/YoomLoading.json"

import ReactGA from 'react-ga';
import { fontSize } from '@mui/system';



export default function LoadingPage(props) {

  const {search} = useLocation();
  const query = new URLSearchParams(search);
  const concert = query.get('concert');
  const concertName = JSON.stringify(concert)
  const [startTime, setStartTime] = useState(0);

  let loadTime;




  useEffect(() => {
 

    if(props.totalToLoad > 0 && props.totalToLoad == props.loaded  ){
      props.setLoadingGlbs(false)
      let endTime = Date.now()
      loadTime = endTime - startTime
      ReactGA.event({category: 'Engagement',action: "page_load",value: loadTime})
      // {ReactGA.event({category: 'Performance', action: "Load Time" ,label:concertName ,value: loadTime})}
      // {ReactGA.event({category: 'Engagement', action: "view" ,label: concertName ,value: 1})}
    }

    
  }, [props.totalToLoad, props.loaded]);


  useEffect(() => {
    setStartTime(Date.now())
  }, []);

  const options = {
    animationData: YoomLoading,
    loop: true
};

const { View } = useLottie(options);


  return (
    <div style={{width:"100%",height:"100%", fontFamily:"inter",textAlign: "center",color:'white' }} >
      {(isBrowser) ? 
      <div>
          <div>
   
            <div style={{position:"absolute",width:"300px", height:"300px", left:"40.25vw",top:"32.25vh"}}> {View}
            <h2 >{ (props.totalToLoad>0 && props.loaded > 0) ? parseInt((props.loaded  *100/(props.totalToLoad))) : 0}%</h2>
            </div>
        </div>
        <div className={"Parent-Middle"}>

          <div style={{marginTop:'30px'}} >
            {/* <img src={Help}/> */}
          </div>
        </div>
        {/* <div className={"Parent-Left"}>
          <img src={"../images/rotatingGuyDesktop.gif"}/>
        </div> */}
        
      </div>

      : 
      <div style={{paddingTop:"10%" }}>
            <div style={{position:"absolute", left:"38vw" ,top:"40vh"}}>
              <div className="loading-item" >
                <div  style={{position:"absolute"}}>{View}
                <h2 style={{ fontSize:"28px" }}>{ (props.totalToLoad>0 && props.loaded > 0) ? parseInt((props.loaded  *100/(props.totalToLoad))) : 0}%</h2>

              </div>

              </div>
            </div>
        <div style={{marginTop:'140px' ,height:"100%"}} >
          {/* <img style={{width:"60%"}} src={Help}/> */}
        </div>
      </div>
    }
    </div>
  )
}